import {
  Avatar,
  Box,
  Card,
  CardContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { LeaveSummary as LeaveSummaryType } from "../../types/types";
import { formatMoney } from "../../utils/formatMoney";
import { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const getStatusColor = (value: number) => {
  if (value <= 120) {
    return "success";
  } else if (value > 120 && value < 150) {
    return "warning";
  } else {
    return "error";
  }
};

const LeaveSummary: React.FC<{ leave: LeaveSummaryType }> = ({ leave }) => {
  const { strings } = useContext(LanguageContext);
  return (
    <>
      <Box mb={2}>
        <Typography mb={3} variant="h6">
          {strings.leave.teambalance}
        </Typography>
        <TableContainer
          sx={{
            mt: 2,
          }}
        >
          <Table aria-label="leave summary table" sx={{ tableLayout: "fixed" }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ pb: 2, pt: 0, fontWeight: "bold", pl: 0 }}>
                  {strings.leave.bookyear}
                </TableCell>
                <TableCell sx={{ pb: 2, pt: 0, fontWeight: "bold" }}>{strings.leave.leavehours}</TableCell>
                <TableCell sx={{ pb: 2, pt: 0, fontWeight: "bold", pr: 0 }}>{strings.leave.value}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key={leave.year}>
                <TableCell sx={{ pl: 0 }}>{leave.year}</TableCell>
                <TableCell>{leave.openBalance.toFixed(0)}</TableCell>
                <TableCell sx={{ pr: 0 }}>{formatMoney.format(leave.openValue)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box mt={5}>
        <Card sx={{ p: 4, mb: 2 }}>
          <CardContent sx={{ p: 0, pb: "0px !important" }}>
            <Grid container spacing={1} alignItems={"center"}>
              <Grid size={9}>
                <Typography variant="h6" sx={{ fontSize: "1.125rem" }}>
                  {strings.leave.perfte}:
                </Typography>
                <Stack direction={"row"} mt={1} spacing={2} alignItems={"center"}>
                  <Stack direction="row" alignItems="center">
                    <Box
                      sx={(theme: Theme) => ({
                        width: 16,
                        height: 16,
                        bgcolor: theme.palette.success.main,
                        mr: 1,
                      })}
                    />
                    <Typography variant="body2">{`<= 120`}</Typography>
                  </Stack>
                  <Stack direction="row" alignItems="center">
                    <Box
                      sx={(theme: Theme) => ({
                        width: 16,
                        height: 16,
                        bgcolor: theme.palette.warning.main,
                        mr: 1,
                      })}
                    />
                    <Typography variant="body2">{`> 120 & < 150`}</Typography>
                  </Stack>
                  <Stack direction="row" alignItems="center">
                    <Box
                      sx={(theme: Theme) => ({
                        width: 16,
                        height: 16,
                        bgcolor: theme.palette.error.main,
                        mr: 1,
                      })}
                    />
                    <Typography variant="body2">{`>= 150`}</Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid size={3}>
                <Stack
                  direction={"row"}
                  spacing={1}
                  useFlexGap
                  sx={{
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Typography variant="h2">{leave.openFteBalance.toFixed(0)}</Typography>
                  <Avatar
                    sx={(theme: Theme) => ({
                      bgcolor: theme.palette[getStatusColor(leave.openFteBalance)].main,
                      width: "30px",
                      height: "30px",
                    })}
                  >
                    &nbsp;
                  </Avatar>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card sx={{ p: 4 }}>
          <CardContent sx={{ p: 0, pb: "0px !important" }}>
            <Grid container spacing={1} alignItems={"center"}>
              <Grid size={9}>
                <Typography variant="h6" sx={{ fontSize: "1.125rem" }}>
                  {strings.leave.noleave}:
                </Typography>
              </Grid>
              <Grid size={3}>
                <Stack
                  direction={"row"}
                  useFlexGap
                  sx={{
                    justifyContent: "flex-end",
                  }}
                >
                  <Typography variant="h2">
                    {leave.noneTaken}
                    <Typography variant="h2" component={"span"} sx={{ ml: 1, opacity: 0.4 }}>
                      / {leave.totalEmployees}
                    </Typography>
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default LeaveSummary;
